import React, { Component } from "react";

export class Screenshot extends Component {
  render() {
    return (
      <div id="screenshot" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Screenshots</h2>
            <p>
              Please check the screenshots to see what you can simplify "copy" action.
            </p>
          </div>
          <div className="row">
            <div className="portfolio-items">
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/01-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                      className = "thumbanchor"
                    >
                      <img
                        src="img/screenshot/01-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/02-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/02-small.jpg"
                        className="img-responsive  scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/03-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/03-small.jpg"
                        className="img-responsive  scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/04-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/04-small.jpg"
                        className="img-responsive  scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/05-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/05-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/06-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/06-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/07-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/07-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/08-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/08-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/screenshot/09-large.jpg"
                      title="Project Title"
                      target = "_blank"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/screenshot/09-small.jpg"
                        className="img-responsive scalableimg"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Screenshot;
